import { getSessionData } from "../../utils/functions/getSessionData";

export const sendSessionData = async (visitorId) => {
  const sessionData = await getSessionData(visitorId);

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_SERVER_URL}profile/sessionData`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(sessionData),
      }
    );

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || "Failed to send session data");
    }

    console.log("Session data sent successfully:", result);
  } catch (error) {
    console.error("Error sending session data:", error);
  }
};
